export default "__VITE_ASSET__ed3b3e66__"